import React from 'react'

import styles from './PricingFlowBlock.module.scss'

import {
  Card as CardIcon,
  LightningAlt as LightningIcon,
  Server as ServerIcon,
  FolderOpen as FolderIcon,
  Invoice as InvoiceIcon,
  CaretRight as ArrowIcon,
} from '../../../icons'

const PricingFlowBlock: React.FC = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Get all SOAX products in one subscription
      </h2>

      <div className={styles.content}>
        <div className={styles.item}>
          <div className={styles.itemIconWrapper}>
            <CardIcon />
          </div>
          <div className={styles.itemLabel}>Subscribe to ANY plan</div>
        </div>

        <div className={styles.arrowBlock}>
          <div className={styles.arrowIconWrapper}>
            <ArrowIcon />
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.itemIconWrapper}>
            <LightningIcon />
          </div>
          <div className={styles.itemLabel}>Get access to all products</div>
          <div className={styles.itemContent}>
            <div className={styles.subItem}>
              <div className={styles.subItemIconWrapper}>
                <ServerIcon />
              </div>
              <div className={styles.subItemLabel}>Proxies</div>
            </div>

            <div className={styles.subItem}>
              <div className={styles.subItemIconWrapper}>
                <FolderIcon />
              </div>
              <div className={styles.subItemLabel}>Web Data API</div>
            </div>
          </div>
        </div>

        <div className={styles.arrowBlock}>
          <div className={styles.arrowIconWrapper}>
            <ArrowIcon />
          </div>
        </div>

        <div className={styles.item}>
          <div className={styles.itemIconWrapper}>
            <InvoiceIcon />
          </div>
          <div className={styles.itemLabel}>
            <p>Spend allocation flexibly</p>
            <p>across products</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingFlowBlock
